import styled, { css } from 'foundations-theming-specialty/utils';
export const BreezeCaretStyle = css(["position:relative;&::after{content:'';display:inline-block;width:", ";height:", ";border-radius:50%;background-color:", ";animation:breezepulse 1s infinite;margin-left:", ";margin-right:", ";}@keyframes breezepulse{0%{transform:scale(1);background-color:#fbdbe9;}50%{transform:scale(1.3);background-color:#ff9fcc;}100%{transform:scale(1);background-color:#fbdbe9;}}"], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.color['breeze-fill-loading-dot-default'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['200']);
export const BreezeLoadingDot = styled('div').attrs({
  role: 'loading',
  'data-loading': true
}).withConfig({
  displayName: "BreezeLoadingDot",
  componentId: "psnv3f-0"
})(["", ""], BreezeCaretStyle);